/* Reuse the theme's existing variant response and accessible product-image modal.
   No extra API requests, trackers, price changes, cart changes, or new popups. */
if (!customElements.get('bb-product-proof')) {
  customElements.define('bb-product-proof', class extends HTMLElement {
    connectedCallback() {
      this.clickHandler = (event) => {
        const trigger = event.target.closest('[data-bb-jump]');
        if (!trigger || !this.contains(trigger)) return;
        const scope = this.closest('product-info');
        const description = scope?.querySelector('.product__description');
        let target;
        switch (trigger.dataset.bbJump) {
          case 'size':
            target = Array.from(description?.querySelectorAll('h2,h3,h4,p,strong') || [])
              .find((el) => /^size (guide|chart)$/i.test(el.textContent.trim())) || description;
            break;
          case 'details': target = description; break;
          case 'gallery': target = scope?.querySelector('media-gallery'); break;
          default: target = scope?.querySelector('variant-selects') || scope?.querySelector('product-form');
        }
        if (!target) return;
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        const focusTarget = target.matches('select,button,input') ? target : target.querySelector('select,button,input') || target;
        if (!focusTarget.matches('select,button,input,a,[tabindex]')) focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
      };
      this.addEventListener('click', this.clickHandler);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.stopVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const scope = this.closest('product-info');
          if (data.sectionId !== (scope?.dataset.originalSection || this.dataset.section)) return;
          const fresh = data.html?.getElementById(`BBProof-${data.sectionId}`);
          if (!fresh) return;
          const opened = Array.from(this.querySelectorAll('details[open]')).map((el) => el.dataset.bbPanel);
          this.innerHTML = fresh.innerHTML;
          this.querySelectorAll('details').forEach((el) => { el.open = opened.includes(el.dataset.bbPanel); });
        });
        this.stopSelection = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          if (this.closest('product-info')?.contains(data.event?.target)) {
            this.querySelector('[data-bb-visuals]')?.setAttribute('hidden', '');
          }
        });
      }
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
      this.stopVariant?.();
      this.stopSelection?.();
    }
  });
}
